<template>
    <!-- 結縁品及下載 -->
    <div class="plowCloudBrief">
        <topBack>{{$t('navName')[4]}}</topBack>
        <!-- 导航 -->
        <barF5></barF5>
        <header class="plowCloudNav flex-between-wrap">
            <div v-for="(item,index) in childNav" :key="index" class="navItem" :class="{'activeNav':index==nowIndex}"
                @click="changeNav($event,index)">{{item.cate_name}}</div>
        </header>
        <barF5></barF5>

        <!-- 内容 -->
        <div class="container">
            <show v-if="nowIndex == 0" :contentList="showList"></show>
            <ideaBook v-if="nowIndex == 1" :contentList="ideaBookList"></ideaBook>
            <downloadBox v-if="nowIndex == 2"></downloadBox>
        </div>
        <!-- 去除底部button所占的位置 -->
        <empty></empty>
        <!-- 底部button -->
        <!-- <footer>
            <Button>{{$t('firstHome')}}</Button>
        </footer> -->
    </div>
</template>

<script>
    import {
        getCateList,
        getGoodsList,
        getEbookList,
        getDownLoadList
    } from "../../api/apis";
    import {
        getNavName
    } from '../../common/js/common.js'
    import topBack from "../../components/topBack.vue";
    import barF5 from "../../components/barF5"; //空隙bar
    import show from "./show"; //安祥禪結縁品
    import ideaBook from "./ideaBook"; //电子书
    import downloadBox from "./downloadBox"; //下载匣

    import empty from "../../components/empty";
    import Button from "../../components/button"; //返回首頁
    export default {
        name: "download",
        components: {
            topBack,
            barF5,
            show,
            ideaBook,
            downloadBox,
            empty,
            Button
        },

        data() {
            return {
                nowIndex: 0,
                cateId: "", //存储当前菜单的cateId
                childNav: [
                    // {
                    //     cate_name: "安祥禪結縁品",
                    //     id: ""
                    // },
                    // {
                    //     cate_name: "安祥禪電子書",
                    //     id: ""
                    // },
                    // {
                    //     cate_name: "下載區",
                    //     id: ""
                    // }
                ],
                showList: [],
                ideaBookList: [],
                downloadBoxList: []
            };
        },
        methods: {
            changeNav(e, index) {
                this.nowIndex = index;
                localStorage.setItem('nowIndex', index);
                this.cateId = this.childNav[index].id
            },
            //获取菜单{}
        },
        mounted() {
            //获取nowIndex
            this.nowIndex = localStorage.getItem('nowIndex') || 0;
            //页面加载时就获取所有页面的数据
            getCateList().then(res => {
                this.childNav = getNavName(res[4]);
                getGoodsList(res[4][0].id).then(res => {
                    this.showList = res
                });
                getEbookList().then(res => {
                    this.ideaBookList = res;
                });
                // getDownLoadList(res[4][2].id).then(res => {
                //   this.downloadBoxList = res;
                // });
            });
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .plowCloudNav {
        /* display: grid;
    grid-template-columns: repeat(2, 49.5%);
    grid-column-gap: 0.15rem;
    grid-row-gap: 0.15rem; */
        padding: 0.64rem;
        text-align: left;
    }

    .navItem {
        width: 9.23rem;
        margin: 0.15rem 0;
        height: 1.71rem;
        box-sizing: border-box;
        line-height: 1.71rem;
        background-color: #f4f3ee;
        color: #666666;
        padding-left: 1.07rem;
        font-size: 0.85rem;
        font-weight: 600;
    }

    .activeNav {
        background-color: #047bcd;
        color: #fff;
    }

    .container {
        /* padding: 0.64rem; */
        color: #333333;
        text-align: left;
    }
</style>